import GLightbox from 'glightbox/src/js/glightbox';

function initLightbox() {
    const lightbox = GLightbox({
        selector: '.lightbox',
        touchNavigation: true,
        loop: true,
    });
}

export default initLightbox;
